import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem } from '@archipro-design/aria';
import { pxToRem } from '@fluentui/react-northstar';

export const TradeOnlyTag: StyleRule = ({ theme }) => ({
    display: 'inline-flex',
    padding: pxArrayToRem([2, 4]),
    textTransform: 'uppercase',
    backgroundColor: theme.siteVariables.colors.grey['300'],
    minHeight: pxToRem(19),
});
